import { GetApiV1ThreeLetterCodePartnerAdminsClientsClientId200 } from '@fukuri-admins/apis/client/gen/model';
import { EditClientFormFieldValues } from '../schema';

type Args = {
  clientData: GetApiV1ThreeLetterCodePartnerAdminsClientsClientId200;
};

type IConvertToFormValues = (args: Args) => EditClientFormFieldValues;

/**
 * custom_field_values 配列をレコードに変換する
 * 同一labelが複数ある場合は配列にまとめる
 */
const groupCustomFieldValuesByLabelAsArray = (
  customFieldValues: NonNullable<
    GetApiV1ThreeLetterCodePartnerAdminsClientsClientId200['client']['custom_field_values']
  >
): Record<string, string | string[]> => {
  return customFieldValues.reduce(
    (acc, field) => {
      const value = field.value.toString();
      const label = field.label;

      if (!acc[label]) {
        acc[label] = value;
        return acc;
      }

      acc[label] = Array.isArray(acc[label]) ? [...acc[label], value] : [acc[label], value];

      return acc;
    },
    {} as Record<string, string | string[]>
  );
};

/**
 * APIレスポンスからフォーム初期値に変換する
 */
export const convertToFormValues: IConvertToFormValues = ({ clientData }) => {
  const { client } = clientData;

  return {
    name: client.name,
    contactPersonName: client.contact_person_name ?? '',
    contactPersonEmail: client.contact_person_email ?? '',
    contactPersonPhone: client.contact_person_phone ?? '',
    corporateNumber: client.corporate_number ?? '',
    externalClientId: client.external_client_id ?? '',
    groupId: client.groups?.[0]?.id?.toString() ?? '',
    employeeCount: client.employee_count ?? '',
    customFields: client.custom_field_values
      ? groupCustomFieldValuesByLabelAsArray(client.custom_field_values)
      : undefined,
    clientFeatureFlags: client.client_feature_flags
      ?.filter(flag => flag.enabled)
      .map(flag => flag.feature_key),
  };
};
